import React from "react";

const ConfirmDeleteModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
}) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
      <div className="bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border text-color p-6 rounded-xl shadow-md max-w-md w-full">
        {title && <h2 className="text-xl font-bold mb-4">{title}</h2>}
        <div className="custom-divider"></div>
        {message && <p className="mb-6">{message}</p>}
        <div className="flex justify-end gap-4">
          <button onClick={onCancel} className="btn-action-white">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn-action">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
